import { Outlet } from 'react-router';

import { useAuth } from '@/domains/auth';
import { DocumentDialog } from '@/domains/documents';
import { FeedbackButton } from '@/domains/feedback';

import { CaseDocumentTitle } from './caseDocumentTitle';
import { Header } from './header';
import { Sidebar } from './sidebar';

export function AppLayout() {
  const { user } = useAuth();
  // Bij een perspectiefwissel de pagina opnieuw opbouwen: lokale paginastate
  // (bv. uitgeschakelde criteria) hoort bij het vorige perspectief.
  const perspectiveKey = user?.activePerspective?.id ?? 'geen-perspectief';

  return (
    <div className="min-h-screen bg-background">
      <CaseDocumentTitle />
      <Sidebar />
      <div className="pl-sidebar print:pl-0">
        <Header />
        <main className="p-6 print:p-0">
          <Outlet key={perspectiveKey} />
        </main>
      </div>
      <DocumentDialog />
      <FeedbackButton />
    </div>
  );
}
